import { render, staticRenderFns } from "./LegacyModal.vue?vue&type=template&id=14128e0b&scoped=true&"
import script from "./LegacyModal.vue?vue&type=script&lang=js&"
export * from "./LegacyModal.vue?vue&type=script&lang=js&"
import style0 from "./LegacyModal.vue?vue&type=style&index=0&id=14128e0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14128e0b",
  null
  
)

export default component.exports